"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startButton = void 0;
const GameAttemptType_1 = require("../../enums/game/GameAttemptType");
const StartButtonType_1 = require("../../enums/game/StartButtonType");
exports.startButton = {
    type: StartButtonType_1.StartButtonType.NORMAL,
    buttonBackgroundImage: '',
    textWhenActive: 'START GAME',
    textBeforeStart: 'STARTS SOON',
    textWhenExpire: 'GAME EXPIRED',
    firstRoundText: '',
    buttonStyle: {
        color: 'ffffff',
        backgroundColor: '46bb97',
        top: '75%',
        fontSize: '28px',
        borderRadius: '30px',
        textAlign: 'center',
    },
    buttonEndStyle: {
        color: 'ffffff',
        backgroundColor: '666d79',
        top: '75%',
        fontSize: '28px',
        borderRadius: '30px',
        textAlign: 'center',
    },
    isHighScoreBarEnabled: true,
    highScoreBackgroundImage: '',
    highScoreText: 'BEST: ',
    previousScoreText: 'LAST: ',
    isRankingEnabled: false,
    rankingText: 'RANKING: ',
    highScoreStyle: {
        color: 'ffffff',
        backgroundColor: '000000',
        fontSize: '16px',
        textAlign: 'center',
        borderRadius: '30px',
    },
    isAttemptsEnabled: false,
    numberOfAttempts: 10,
    attemptType: GameAttemptType_1.GameAttemptType.TOTAL,
};
